import { MOBILE_SCREEN_QUERY } from "../../js/shared.0f27bac2f95c.js";
import TomSelect from "../../js/tom-select/tom-select.0c9bda91e62b.js";
import { createOptionRenderer } from "./pet-tomselect-utils.b93c6b1d8b56.js";
import { addTomSelectAriaLabel } from "../../js/fancy-dropdowns.d2d8f5945e1a.js";
import { FloatingLabel } from "../../js/floating-label.895f0e243516.js";

class PetLocationSelector extends HTMLElement {
  constructor() {
    super();
    this.displayDisabled = this.hasAttribute("data-display-disabled");
    this.standalone = this.hasAttribute("data-standalone");
  }

  connectedCallback() {
    this.locationSelectorEl = this.querySelector("select");
    this.parentEl = this.locationSelectorEl.parentElement;
    // store a reference to this PetLocationSelector instance,
    // so its properties can be accessed inside the TomSelect instance
    const that = this;
    this.dropdown = new TomSelect(this.locationSelectorEl, {
      dropdownParent: this.parentEl,
      labelField: "label",
      searchField: "label",
      duplicates: true,
      onDropdownClose: () => {
        if (document.activeElement === this.dropdown.control_input) {
          this.advance();
        }
      },
      render: {
        option: createOptionRenderer(that.displayDisabled),
      },
    });

    addTomSelectAriaLabel(this.locationSelectorEl, this.dropdown);

    this.dropdown.on("change", this.advance);

    FloatingLabel.withTomSelect(this, this.dropdown);
  }

  advance = (e) => {
    if (this.standalone || MOBILE_SCREEN_QUERY.matches) {
      document.activeElement.blur();
    } else {
      const insuranceSelector = document.getElementById("pet-insurance");
      insuranceSelector.focus();
    }

    // A search that matches no facility leaves the dropdown without an active
    // option, so closing it announces no location change.
    const activeOption = this.dropdown.activeOption;
    if (!activeOption) return;

    document.dispatchEvent(
      new CustomEvent("tqc:pet-location-changed", {
        detail: {
          providerId: this.dropdown.getValue(),
          label: activeOption.textContent,
        },
        bubbles: true,
      }),
    );
  };
}

window.customElements.define("pet-location-selector", PetLocationSelector);
